/**
 * Meetings Actions
 * Talkroute
 *
 * Created by Vel Genov on 07/22/21
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * The external dependencies
 */
import React, { useState } from "react";
import ReactDOM from 'react-dom';
/**
 * The internal dependencies
 */
import CameraPlayIcon from "@resources/icons/camera-play.svg";
import CalendarFullIcon from "@resources/icons/calendar-full.svg";
import PlusSquare from "@resources/icons/plus-square.svg";
import {
  MeetingButton,
  MeetingButtonIcon,
  ButtonsGrid,
  ButtonsGridItem,
  MeetingButtonText,
} from "./Actions.styles";
import {
  MEETINGS_JOIN,
  MEETINGS_NEW_MEETING,
  MEETINGS_SCHEDULE_MEETING,
  MEETINGS_SHARE_SCREEN,
} from "@components/Meetings/constants";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { MeetingsRouteActions, routeUrlBuilders } from "@constants/routes";
import ScheduleMeetingDialog from "./ScheduleMeetingDialog";
import { JoinMeetingDialog } from "./JoinMeetingDialog";

/**
 * Meetings Details Component
 */
export default function MeetingsActions() {
  const [openMeetingDialog, setOpenMeetingDialog] = useState(false)
  const [joinMeetingDialog, setJoinMeetingDialog] = useState(false)
  const dispatch = useDispatch();

  const startNewMeeting = () => {
    dispatch(push(routeUrlBuilders.MEETINGS_IFRAME(MeetingsRouteActions.NEW_MEETING)))
  }

  const startScreenSharingSession = () => {
    dispatch(push(routeUrlBuilders.MEETINGS_IFRAME(MeetingsRouteActions.NEW_SCREENSHARING_MEETING)))
  }

  const JoinDialog = () => {
    return (
      <JoinMeetingDialog
        open={joinMeetingDialog} 
        onClose={() => setJoinMeetingDialog(false)}
      />
    )
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "0",
        height: "100%",
        width: "100%"
      }}
    >
      <ScheduleMeetingDialog 
        open={openMeetingDialog} 
        close={() => setOpenMeetingDialog(false)}
      />
      <JoinDialog />
      <ButtonsGrid>
        <ButtonsGridItem>
          <MeetingButton onClick={startNewMeeting}>
            <MeetingButtonIcon className="icon-wrap">
              <CameraPlayIcon width="45" />
            </MeetingButtonIcon>

            <MeetingButtonText>{MEETINGS_NEW_MEETING}</MeetingButtonText>
          </MeetingButton>
        </ButtonsGridItem>

        <ButtonsGridItem >
          <MeetingButton onClick={() => setJoinMeetingDialog(true)}>
            <MeetingButtonIcon className="icon-wrap">
              <PlusSquare width="38" />
            </MeetingButtonIcon>

            <MeetingButtonText>{MEETINGS_JOIN}</MeetingButtonText>
          </MeetingButton>
        </ButtonsGridItem>

        <ButtonsGridItem>
          <MeetingButton onClick={() => setOpenMeetingDialog(true)}>
            <MeetingButtonIcon className="icon-wrap">
              <CalendarFullIcon width="45" />
            </MeetingButtonIcon>

            <MeetingButtonText>{MEETINGS_SCHEDULE_MEETING}</MeetingButtonText>
          </MeetingButton>
        </ButtonsGridItem>

        {/* <ButtonsGridItem onClick={startScreenSharingSession}>
          <MeetingButton>
            <MeetingButtonIcon className="icon-wrap">
              <ExitUpIcon width="38" height="auto" />
            </MeetingButtonIcon>

            <MeetingButtonText>{MEETINGS_SHARE_SCREEN}</MeetingButtonText>
          </MeetingButton>
        </ButtonsGridItem> */}
      </ButtonsGrid>
    </div>
  );
}
